/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import React from 'react';

import { TimelineProvider } from '../timeline/TimelineContext';
import TimelineScheduler from '../ClinicianView/TimelineScheduler';

import LoadingPageText from '../../common/Loading/LoadingPageText';
import { useFetchPlanningDetails } from '../../../actions/areas/planner';

export function TreatmentViewPage() {
  document.title = 'Planner treatment view';
  const includeTreatments = true;
  const {
    data: timeLineData,
    isDataLoading,
    baseRequestModel,
    isUpdateTriggered,
    error,
    refresh,
  } = useFetchPlanningDetails(includeTreatments);

  if (isDataLoading)
    return <LoadingPageText showHeader={false}>Wait a moment while we gather timeline info...</LoadingPageText>;

  const timelineSettings = {
    ...timeLineData,
    baseRequestModel,
    isUpdateTriggered,
    error,
    includeTreatments,
    toggleForceRefresh: refresh,
  };

  return (
    <section className="planning-content-wrapper">
      <TimelineProvider>
        <TimelineScheduler settings={timelineSettings} />
      </TimelineProvider>
    </section>
  );
}
